import { Vector3 } from 'three';
import * as THREE from 'three/build/three.module';
import { J3CameraUtils } from './J3CameraUtils';
import { BillboardInfo } from './J3TypeList';

export class J3BillboardHelper extends EventTarget {

    billboards = [];

    constructor(public wrapper: THREE.Object3D = null, public prefix, public groupid: string = 'none', public enable: boolean = true, public imagecommon, public tagcommon, public data) {
        // wrapper //親オブジェクト
        // id:string = 'none'; //ビルボードグループのID名
        // enable:boolean = true;   //ビルボードを有効にするか？
        // imagecommon;     //イメージの共通データ
        // tagcommon;     //タグの共通データ
        // data;   //ビルボードのデータ JSON-'billboards'
        super();
        console.log('J3BillboardHelper', groupid, enable, imagecommon.imagedir, tagcommon.image, data[0].name);
        wrapper.name = groupid; //ラッパーの名前はグループIDにする
        this.SetBillboards();
    }

    Update(cameraUtils: J3CameraUtils) {
        //J3ThreeSubのUpdateループからコールされる
        this.FaceToCamera(cameraUtils, false);
    }

    FaceToCamera(cameraUtils: J3CameraUtils, forced = false) {
        if (cameraUtils == null) return;
        //タグをカメラに正対させる
        /*
        if (this.tagcommon.faceToCamera || forced) {
            for (const bill of this.billboards) {
                bill.tag.rotation.setFromRotationMatrix(cameraUtils.camera.matrix);
            }
        }
        */
        //ビルボード画像をカメラに正対させる
        if (this.imagecommon.faceToCamera || forced) {
            for (const bill of this.billboards) {
                //bill.tag.rotation.setFromRotationMatrix(cameraUtils.camera.matrix);
                //bill.image.rotation.setFromRotationMatrix(cameraUtils.camera.matrix);
                //bill.close.rotation.setFromRotationMatrix(cameraUtils.camera.matrix);
                bill.group.rotation.setFromRotationMatrix(cameraUtils.camera.matrix);
            }
        }
    }

    MakeBillboardObjects(geometry: THREE.geometry, tagMaterial: THREE.material, closeBtnMaterial: THREE.material = null, linkBtnMaterial: THREE.material = null) {
        //各タグとビルボードと「閉じる」「リンク」ボタンの作成
        const degToRad = Math.PI / 180.0;
        for (const elem of this.data) {
            if (!elem.load) continue;    //スキップ

            //グループ
            const group = new THREE.Group();
            this.wrapper.attach(group);
            const idname = this.prefix;
            group.name = idname + '_' + this.groupid + '_' + elem.name;
            const pos = elem.pos;
            group.position.set(pos[0], pos[1], pos[2]);
            group.scale.set(1, 1, 1);

            //ビルボード（グループのサブグループ）
            const billGroup = new THREE.Group();
            group.attach(billGroup);
            billGroup.name = idname + '_' + this.groupid + '_' + elem.name + '_bill';
            billGroup.position.set(0, 0, 0);
            billGroup.scale.set(1, 1, 1);   //仮に１にしておく。後で指定したスケールに変更する
        

            //console.log('group', group.name, group.position);

            //0.タグ、1.画像、2.閉じるボタン、3.リンクボタンを作成
            let scl: number[], scl0: number[], scl1: number[], scl2: number[], scl3: number[];

            // 0 タグ
            const quad = new THREE.Mesh(geometry, tagMaterial);
            group.attach(quad); //position/rotationをセットする前にグループに入れるとローカル座標での指定になる
            quad.name = idname + '_' + this.groupid + '_' + this.tagcommon.action + '_' + elem.name;
            quad.position.set(0, 0, 0);
            const rot = elem.rot;
            quad.rotation.set(rot[0] * degToRad, rot[1] * degToRad, rot[2] * degToRad);
            scl = this.tagcommon.scale;
            quad.scale.set(scl[0], scl[1], scl[2]);
            //console.log('tag', quad.name, quad.position);

            // 2「閉じる」ボタン
            let quad2: THREE.Mesh;
            if (closeBtnMaterial) {
                quad2 = new THREE.Mesh(geometry, closeBtnMaterial);
                billGroup.attach(quad2);
                quad2.name = idname + '_' + this.groupid + '_' + this.imagecommon.closeButton.action + '_' + elem.name;
                const pos2 = this.imagecommon.closeButton.offset;
                quad2.position.set(pos2[0], pos2[1], pos2[2]);
                const rot2 = elem.rot;
                quad2.rotation.set(rot2[0] * degToRad, rot2[1] * degToRad, rot2[2] * degToRad);
                scl2 = this.imagecommon.closeButton.scale;
                quad2.scale.set(scl2[0], scl2[1], scl2[2]);
                //console.log('closeBtn', quad2.name, quad2.position);
            }

            // 3「リンク」ボタン
            let quad3: THREE.Mesh;
            if (linkBtnMaterial) {
                quad3 = new THREE.Mesh(geometry, linkBtnMaterial);
                billGroup.attach(quad3);
                quad3.name = idname + '_' + this.groupid + '_' + this.imagecommon.linkButton.action + '_' + elem.name;
                //console.log('link button', quad3.name);
                const pos3 = this.imagecommon.linkButton.offset;
                quad3.position.set(pos3[0], pos3[1], pos3[2]);
                const rot3 = elem.rot;
                quad3.rotation.set(rot3[0] * degToRad, rot3[1] * degToRad, rot3[2] * degToRad);
                scl3 = this.imagecommon.linkButton.scale;
                quad3.scale.set(scl3[0], scl3[1], scl3[2]);
                //console.log('linkBtn', quad2.name, quad2.position);
            }

            // 1 ビルボード
            const textureLoader1 = new THREE.TextureLoader();
            textureLoader1.load(this.imagecommon.imagedir + elem.image.image, (texture1) => {
                texture1.encoding = THREE.sRGBEncoding;
                const material1 = new THREE.MeshBasicMaterial({
                    map: texture1,
                    color: elem.image.color,
                    transparent: false,
                });
                const quad1 = new THREE.Mesh(geometry, material1);
                billGroup.attach(quad1);
                const action = 'none';  //イメージクリックのアクション
                quad1.name = idname + '_' + this.groupid + '_' + action + '_' + elem.name;
                let offset1 = elem.image.offsetpos;
                //const pos1 = [pos[0] + offset1[0], pos[1] + offset1[1], pos[2] + offset1[2]];
                const pos1 = [offset1[0], offset1[1], offset1[2]];
                quad1.position.set(pos1[0], pos1[1], pos1[2]);

                const rot1 = [rot[0], rot[1], rot[2]];
                quad1.rotation.set(rot1[0] * degToRad, rot1[1] * degToRad, rot1[2] * degToRad);
                //scl0 = elem.image.scale;    //各ビルボードのスケール
                scl1 = elem.image.scale;
                //[baseScale[0] * scl0[0], baseScale[1] * scl0[1], baseScale[2] * scl0[2]];
                quad1.scale.set(scl1[0], scl1[1], scl1[2]);

                //グループのスケール
                
                scl0 = elem.scl;  //共通スケール
                billGroup.scale.set(scl0[0], scl0[1], scl0[2]);

                //console.log('quad1', quad1.name, quad1.position);

                let url: string = '#';
                if (elem.linkURL) url = elem.linkURL;
                const billboard: BillboardInfo = { group: group, name: elem.name, connect: elem.connect, tag: quad, billboard:billGroup, image: quad1, close: quad2, link: quad3, tagscale: scl, billboardscale:scl0, imagescale: scl1, closescale: scl2, linkscale: scl3, linkURL: url };  //タグとビルボード画像のオブジェクトを配列に格納
                this.billboards.push(billboard);
                //console.log('Bill', quad.name, quad1.name, quad2.name);

                if (elem.line.draw) {
                    const pos1 = [pos[0], pos[1] - scl[1] / 2, pos[2]];
                    this.DrawLine(pos1, elem.line.footpos, rot, scl, elem.line.color);
                    console.log('drawline', elem.name);
                }

                //初期状態（タグまたは画像）の選択
                if (elem.hide) {
                    this.EraseTagAndImage(billboard);   //タグ・画像両方非表示
                } else {
                    if (elem.showImage) {
                        this.SwitchToImage(billboard);  //画像を表示
                    } else {
                        this.SwitchToTag(billboard);    //タグを表示
                    }
                }
            });
        }
    }

    SetLinkButtonTexture(geometry: THREE.geometry, tagMaterial: THREE.material, closeBtnMaterial: THREE.material = null) {
        if (this.imagecommon.linkButton.enable) {
            //「リンク」ボタン画像のロード
            const textureLoader = new THREE.TextureLoader();
            textureLoader.load(this.imagecommon.linkButton.dir + this.imagecommon.linkButton.image, (texture) => {
                console.log('Billboard linkButton image load success', texture.name);
                texture.encoding = THREE.sRGBEncoding;
                const linkBtnMaterial = new THREE.MeshBasicMaterial({
                    map: texture,
                    color: this.imagecommon.linkButton.color,
                    transparent: true,
                    alphaTest: 0.5,
                });
                this.MakeBillboardObjects(geometry, tagMaterial, closeBtnMaterial, linkBtnMaterial);
            })
        } else {
            this.MakeBillboardObjects(geometry, tagMaterial, closeBtnMaterial, null);
        }
    }

    SetCloseButtonTexture(geometry: THREE.geometry, tagMaterial: THREE.material) {
        if (this.imagecommon.closeButton.enable) {
            //「閉じる」ボタン画像のロード
            const textureLoader = new THREE.TextureLoader();
            textureLoader.load(this.imagecommon.closeButton.dir + this.imagecommon.closeButton.image, (texture) => {
                console.log('Billboard closeButton image load success', texture.name);
                texture.encoding = THREE.sRGBEncoding;
                const closeBtnMaterial = new THREE.MeshBasicMaterial({
                    map: texture,
                    color: this.imagecommon.closeButton.color,
                    transparent: true,
                    alphaTest: 0.5,
                });
                this.SetLinkButtonTexture(geometry, tagMaterial, closeBtnMaterial);
            })
        } else {
            this.SetLinkButtonTexture(geometry, tagMaterial, null);
        }
    }

    //DrawTag(name: string, imagename: string, ipos = [0, 0, 0], fpos = [0, 0, 0], rot = [0, 0, 0], scl = [1, 1, 1], drawLine=false, linecolor = 0xffffff, widthSegments = 4, heightSegments = 4) {
    SetBillboards(widthSegments = 4, heightSegments = 4) {
        if (this.wrapper == null) return;
        if (!this.enable) return;

        //タグ画像のロード。画像名を受けて画像をロードし、environments配列に格納する
        const geometry = new THREE.PlaneGeometry(1, 1, widthSegments, heightSegments);
        const textureLoader = new THREE.TextureLoader();
        console.log(this.tagcommon.imagedir + this.tagcommon.image);
        textureLoader.load(this.tagcommon.imagedir + this.tagcommon.image, (texture) => {
            console.log('Billboard tag load success', texture.name);
            texture.encoding = THREE.sRGBEncoding;
            const material = new THREE.MeshBasicMaterial({
                //const material = new THREE.MeshToonMaterial({
                map: texture,
                color: this.tagcommon.color,
                transparent: true,
                alphaTest: 0.5,
            });

            this.SetCloseButtonTexture(geometry, material);
        })
    }

    DrawLine(ipos = [0, 0, 0], fpos = [0, 0, 0], rot = [0, 0, 0], scl = [1, 1, 1], linecolor = 0xffffff) {
        const points = [];
        points.push(new Vector3(ipos[0], ipos[1], ipos[2]));
        points.push(new Vector3(fpos[0], fpos[1], fpos[2]));
        const material = new THREE.LineBasicMaterial({ color: linecolor });
        const geometry = new THREE.BufferGeometry().setFromPoints(points);
        const line = new THREE.Line(geometry, material);
        this.wrapper.add(line);
    }

    SwitchToTag(billboard: BillboardInfo) {
        billboard.image.visible = false;
        billboard.billboard.scale.set(0, 0, 0);
        /*billboard.image.scale.set(0, 0, 0);
        if (billboard.close) {
            billboard.close.visible = false;
            billboard.close.scale.set(0, 0, 0);
        }
        if (billboard.link) {
            billboard.link.visible = false;
            billboard.link.scale.set(0, 0, 0);
        }
        */
        billboard.tag.visible = true;
        const scl = billboard.tagscale;
        console.log('SwitchToTag', scl);
        billboard.tag.scale.set(scl[0], scl[1], scl[2]);
    }
    SwitchToImage(billboard: BillboardInfo) {
        billboard.image.visible = true;
        const scl0 = billboard.billboardscale;
        console.log('SwitchToImage', scl0);
        billboard.billboard.scale.set(scl0[0], scl0[1], scl0[2]);
        /*
        const scl = billboard.imagescale;
        billboard.image.scale.set(scl[0], scl[1], scl[2]);
        if (billboard.close) {
            billboard.close.visible = true;
            const scl2 = billboard.closescale;
            billboard.close.scale.set(scl2[0], scl2[1], scl2[2]);
        }
        if (billboard.link) {
            billboard.link.visible = true;
            const scl3 = billboard.linkscale;
            billboard.link.scale.set(scl3[0], scl3[1], scl3[2]);
        }
        */
        billboard.tag.visible = false;
        billboard.tag.scale.set(0, 0, 0);
    }
    EraseTagAndImage(billboard: BillboardInfo) {
        billboard.image.visible = false;
        billboard.billboard.scale.set(0,0,0);
        /*
        billboard.image.scale.set(0, 0, 0);
        if (billboard.close) {
            billboard.close.visible = false;
            billboard.close.scale.set(0, 0, 0);
        }
        if (billboard.link) {
            billboard.link.visible = false;
            billboard.link.scale.set(0, 0, 0);
        }
        */
        billboard.tag.visible = false;
        billboard.tag.scale.set(0, 0, 0);
    }

    DoAction(idname: string) {
        const _groupid = idname.split('_')[1];
        if (_groupid != this.groupid) return;    //グループIDが異なる場合は何もしない
        //console.log('DoAction', idname);

        const action = idname.split('_')[2].toLowerCase();   //アクションを取得
        if (action == 'close') {
            //console.log('CLOSE');
            this.ShowTag(idname);
        } else if (action == 'openimage') {
            //console.log('OPEN IMAGE');
            this.ShowImage(idname);
        } if (action == 'gotolink') {
            //console.log('GOTO LINK' );
            this.OpenLink(idname);
        } else {
            console.log('ACTION not defined');
        }
    }

    OpenLink(idname: string) {
        const _groupid = idname.split('_')[1];
        if (_groupid != this.groupid) return;
        //console.log('GoToLink', idname);
        const _elemname = idname.split('_')[3];
        let target:string = '_self';
        if(this.imagecommon.linkButton.linkTarget) target = this.imagecommon.linkButton.linkTarget;
        for (const bill of this.billboards) {
            if (bill.name == _elemname) {
                if(target == '_self'){
                    location.href = bill.linkURL;
                }else{
                    window.open(bill.linkURL);
                }
                break;
            }
        }
    }

    ShowTag(imagename: string) {
        const _groupid = imagename.split('_')[1];
        if (_groupid != this.groupid) return;
        //console.log('ShowTag', imagename);
        const _elemname = imagename.split('_')[3];
        for (const bill of this.billboards) {
            if (bill.name == _elemname) {
                this.SwitchToTag(bill);
                break;
            }
        }
    }
    ShowImage(tagname: string) {
        const _groupid = tagname.split('_')[1];
        if (_groupid != this.groupid) return;
        //console.log('ShowImage', tagname);
        const _elemname = tagname.split('_')[3];
        for (const bill of this.billboards) {
            if (bill.name == _elemname) {
                this.SwitchToImage(bill);
                break;
            }
        }
    }

    EraseAll() {
        console.log('EraseAll');
        //すべてのタグ・ビルボードを非表示にする
        for (const bill of this.billboards) {
            this.EraseTagAndImage(bill);
        }
    }


    ShowAllTags() {
        console.log('ShowAllTags');
        //すべてのタグを表示、画像を非表示にする
        for (const bill of this.billboards) {
            this.SwitchToTag(bill);
        }
    }

    ShowAllImages() {
        console.log('ShowAllImages');
        //すべてのタグを非表示、画像を表示にする
        for (const bill of this.billboards) {
            this.SwitchToImage(bill);
        }
    }


    FilterConnectedBillboards(currentDomeName: string = '') {
        //現在のドーム名から番号部分を取り出す
        const domeNumStr: string = (currentDomeName.split('.')[0]).slice(1);
        console.log('J3BillboardHelper:currentDome', domeNumStr, currentDomeName);

        for (const bill of this.billboards) {
            this.EraseTagAndImage(bill);    //タグ・画像を消去
            for (const num of bill.connect) {
                if (num == domeNumStr) {
                    this.SwitchToTag(bill); //タグを表示
                    break;
                }
            }
        }
    }

}